import React from 'react';
import { ImageWithModal } from '../common';

interface CongressGalleryProps {
  photos: string[];
}

export default function CongressGallery({ photos }: CongressGalleryProps) {
  return (
    <div className="flex flex-col flex-wrap w-full p-16 bg-gray-100">
      <article className="w-full flex flex-row flex-wrap -mx-4">
        {photos.map((photo) => (
          <div
            className="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 px-4 mb-8"
            key={photo}
          >
            <ImageWithModal key={photo} src={photo} />
          </div>
        ))}
      </article>
    </div>
  );
}
